module.exports = __webpack_public_path__ + "img/行业现状.1aa45320.jpg";